<template>
  <div class="welfare">
    <div class="xiao_title">企业福利</div>
    <div class="Tdescribe">大平台，大关爱  ——  360度全场景关怀，构建企业与员工共生共赢新生态！</div>
    <div class="center wrapW">
      <ul class="left">
        <li>
          <div class="name">年节福利关怀</div>
          <div class="info">女神节、端午节、劳动节...根据不同节日推出相应产品</div>
        </li>
        <li>
          <div class="name">生日关怀</div>
          <div class="info">蛋糕卡、商城E卡</div>
        </li>
        <li>
          <div class="name">企业专属员工福利商城</div>
          <div class="info">搭建企业专属的福利关爱平台平台要数据，利润返E卡，E卡惠员工</div>
        </li>
      </ul>
      <img src="~@/assets/img/welfare.png">
      <ul class="right">
        <li>
          <div class="name">健康体检</div>
          <div class="info">关注员工健康，体现最深层次的企业关怀</div>
        </li>
        <li>
          <div class="name">企业文化</div>
          <div class="info">成长培训、团队建设员工职业生涯规划</div>
        </li>
        <li>
          <div class="name">激励奖励</div>
          <div class="info">瀚礼E卡&旅游出行</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'welfare',
  data () {
    return {
    }
  }
}
</script>
<style lang="stylus" scoped>
.welfare
  margin-top 1.2rem
  text-align center
  background #F4F5F7
  padding .59rem 0
  .center
    display flex
    margin-top 1.16rem
    img
      width 54%
    ul
      width 23%
      li
        margin-top 40%
        height 17%
        .name
          font-size .18rem
          color #333
          line-height .5rem
          height .5rem
          font-weight 400
        .info
          font-size .14rem
          color #666
          line-height .18rem
      li:first-child
        margin-top 0px
    ul.left
      text-align right
      padding-right .4rem
    ul.right
      text-align left
      padding-left .4rem
</style>



// WEBPACK FOOTER //
// src/pages/index/components/welfare.vue